const plugin = {
  id: 'recovr.link.ReleaseNotes',
  matches: {
    use: 'userBar',
    client: 'Main'
  },
  name: 'Release Notes',
  layout: {
    group: ['help'],
    sort: '_a.bb'
  },
  handles: () => true,
  appearance: () => {
    return {
      name: 'Release Notes'
    };
  },
  perform: () => {
    window.open('https://releases.recovr.biz', '_blank');
  }
};
export default {
  install(molten) {
    molten.addPlugin('Action', plugin);
  }
};